import React from 'react';
import { Dumbbell, Instagram, Facebook, MapPin, Phone } from 'lucide-react';
import { navLinks, brand, branches, social } from '../data/mock';

export default function Footer() {
  return (
    <footer className="relative bg-slate-950 text-white pt-16 pb-8 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-amber-400 ring-2 ring-amber-400/30">
                <img src={brand.logo} alt="Body Line Gym" className="w-full h-full object-cover" />
              </div>
              <span className="font-anton text-xl">{brand.name}<span className="text-blue-500">.</span></span>
            </div>
            <p className="mt-4 text-white/60 text-sm leading-relaxed">
              Transform your body. Transform your life. Unisex fitness gym across multiple branches.
            </p>
            <div className="mt-5 flex gap-2">
              <a href={social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="w-9 h-9 rounded-full bg-white/5 hover:bg-pink-600 border border-white/10 flex items-center justify-center transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href={social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="w-9 h-9 rounded-full bg-white/5 hover:bg-blue-600 border border-white/10 flex items-center justify-center transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <p className="section-eyebrow text-white/50">Quick Links</p>
            <ul className="mt-4 space-y-2">
              {navLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-white/70 hover:text-blue-400 text-sm transition-colors">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="section-eyebrow text-white/50">Branches</p>
            <ul className="mt-4 space-y-3">
              {branches.map((b) => (
                <li key={b.name} className="text-white/70 text-sm">
                  <p className="font-semibold text-white">{b.name}</p>
                  <p className="text-xs mt-0.5 flex items-start gap-1">
                    <MapPin className="w-3 h-3 mt-0.5 text-blue-400 flex-shrink-0" />
                    {b.address}
                  </p>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="section-eyebrow text-white/50">Contact</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-center gap-2 text-white/70">
                <Phone className="w-3.5 h-3.5 text-blue-400" />
                +91 84820 31021
              </li>
              <li className="text-white/70">contact@bodylinegym.in</li>
              <li className="text-white/70 text-xs pt-2">
                <span className="text-amber-400">Timings:</span> Mon–Sat 6–13 & 16–22 · Sun Closed
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/50">© {new Date().getFullYear()} Body Line Gym. All rights reserved.</p>
          <p className="text-xs text-white/50">Made with strength & discipline.</p>
        </div>
      </div>
    </footer>
  );
}
